export default __webpack_public_path__ + "static/media/online-pk-5-button.df6b1191.svg";